import { render, staticRenderFns } from "./slave_title.vue?vue&type=template&id=fa8ea57e"
import script from "./slave_title.vue?vue&type=script&lang=js"
export * from "./slave_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports